import React, { useMemo } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

const DEFAULT_COLORS = [
  '#0AC6BD',
  '#D8F6F5',
  '#6CDDD7',
  '#E6FAFB',
  '#3BD1CA',
  '#48C2C7',
  '#A1E3E4',
  '#E6FAFB',
  '#C3EFF1',
  '#2DC9C8',
];
const RAD = Math.PI / 180;

function PillLabel({ cx, cy, midAngle, outerRadius, name }) {
  const radius = outerRadius + 12; // distância da borda
  const x = cx + radius * Math.cos(-midAngle * RAD);
  const y = cy + radius * Math.sin(-midAngle * RAD);

  // "pílula" simples em SVG (retângulo arredondado) com largura aproximada
  const paddingX = 8;
  const paddingY = 6;
  const charW = 7; // aproximação
  const textWidth = (name?.length || 0) * charW;
  const pillW = textWidth + paddingX * 2;
  const pillH = 24;

  // centraliza a pílula no ponto calculado
  const rectX = x - pillW / 2;
  const rectY = y - pillH / 2;

  return (
    <g>
      <rect x={rectX} y={rectY} width={pillW} height={pillH} rx={pillH / 5} fill="#fff" />
      <text
        x={x}
        y={y + 1}
        fill="#143145"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={12}
        fontWeight={500}
      >
        {name}
      </text>
    </g>
  );
}

export default function DonutChart2({
  data, // [{ label: 'Vitalício', percent: 42 }, ...]
  valueKey = 'percent',
  nameKey = 'label',
  colors = DEFAULT_COLORS,
  height = 210,
}) {
  // garante números válidos
  const safeData = useMemo(
    () =>
      (data || []).map((d) => ({
        ...d,
        [valueKey]: Number(d[valueKey]) || 0,
      })),
    [data, valueKey]
  );

  return (
    <div className="w-full" style={{ height }}>
      <ResponsiveContainer>
        <PieChart>
          <Tooltip
            wrapperStyle={{ zIndex: 9999 }}
            formatter={(value, name, props) => {
              return [`${value}%`, name];
            }}
          />
          <Pie
            data={safeData}
            dataKey={valueKey}
            nameKey={nameKey}
            innerRadius="40%"
            startAngle={90} // começa no topo
            endAngle={-270} // sentido horário
            labelLine={false}
            label={(props) => <PillLabel {...props} name={props.name} />}
            stroke="none"
          >
            {safeData.map((_, i) => (
              <Cell key={i} fill={colors[i % colors.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
